import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import apiClient from '../services/apiClient';
import { Modal } from '../components/common';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Feedback = styled.div`
  color: ${({ $error, theme }) => ($error ? theme.colors.danger : theme.colors.txtPrincipal)};
  font-size: 13px;
`;

const NoUsarTag = styled.span`
  margin-left: 6px;
  font-size: 0.75em;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.danger};
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 2px;
`;

const Th = styled.th`
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  padding: 6px 8px;
  text-align: ${({ $align = 'left' }) => $align};
  font-size: 12px;
  font-weight: 700;
  background: ${({ theme }) => theme.colors.bgSecundario};
`;

const Td = styled.td`
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  padding: 5px 8px;
  text-align: ${({ $align = 'left' }) => $align};
  font-size: 12px;
`;

const UseButton = styled.button`
  height: 24px;
  min-width: 24px;
  padding: 0 6px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.bgSecundario};
  color: ${({ theme }) => theme.colors.success};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export default function EquivalenciasModal({ repuestoId, obraId, open, onClose, onSelect, stockDisponible, stockInsuficiente }) {
  const [loading, setLoading] = useState(false);
  const [equivalentes, setEquivalentes] = useState([]);
  const [repuesto, setRepuesto] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !repuestoId) return;
    setLoading(true);
    setError('');
    const params = obraId ? { obra: obraId } : {};
    apiClient.get(`/repuestos/${repuestoId}/equivalencias/`, { params })
      .then((resp) => {
        setEquivalentes(resp.data.equivalentes || []);
        setRepuesto(resp.data.repuesto || null);
      })
      .catch((err) => setError('No se pudieron cargar equivalencias.'))
      .finally(() => setLoading(false));
  }, [open, repuestoId, obraId]);

  return (
    <Modal open={open} onClose={onClose} title={repuesto ? `Equivalentes para ${repuesto.codigo} - ${repuesto.descripcion}` : 'Equivalentes'}>
      <Body>
        {stockInsuficiente && stockDisponible !== undefined ? (
          <Feedback $error>
            Stock insuficiente en el depósito de origen. Disponible: <strong>{stockDisponible}</strong> u. Seleccioná un equivalente con stock para continuar.
          </Feedback>
        ) : (
          <Feedback>Seleccioná un repuesto para reemplazar al solicitado originalmente.</Feedback>
        )}
        {loading ? <Feedback>Cargando...</Feedback> : null}
        {error ? <Feedback $error>{error}</Feedback> : null}
        {!loading && !error && (
          <StyledTable>
            <thead>
              <tr>
                <Th>Código</Th>
                <Th>Marca</Th>
                <Th>Descripción</Th>
                {obraId ? <Th $align="center">Stock obra</Th> : null}
                <Th $align="center">Stock total</Th>
                <Th $align="center">Usar</Th>
              </tr>
            </thead>
            <tbody>
              {equivalentes.length === 0 && (
                <tr>
                  <Td colSpan={obraId ? 6 : 5} $align="center">Sin equivalentes configurados</Td>
                </tr>
              )}
              {equivalentes.map((e) => (
                <tr key={e.id}>
                  <Td>
                    {e.codigo}
                    {e.no_usar && <NoUsarTag title="Repuesto discontinuado: no conviene pedirlo">NO USAR</NoUsarTag>}
                  </Td>
                  <Td>{e.marca_nombre || '-'}</Td>
                  <Td>{e.descripcion || '-'}</Td>
                  {obraId ? <Td $align="center">{e.stock_en_obra ?? '-'}</Td> : null}
                  <Td $align="center">{e.stock_total ?? 0}</Td>
                  <Td $align="center">
                    <UseButton type="button" onClick={() => onSelect(e)} title="Seleccionar equivalente">
                      <i className="bi bi-arrow-left-right" />
                    </UseButton>
                  </Td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        )}
      </Body>
    </Modal>
  );
}
